import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

import Button from '../../general/Button/Button';
import logo from '../../../assets/logo.svg';

import 'font-awesome/css/font-awesome.min.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  return (
    <header className="headerContainer">
      <div className="logoAndHamburger">
        <Link to="/">
          <img src={logo} alt="Logo" />
        </Link>

        <button className="hamburger" onClick={toggleMenu}>
          <i className={`fa fa-bars hamburgerIcon`}></i>
        </button>
      </div>

      <nav className={`nav ${isMenuOpen ? 'active' : ''}`}>
         <Link to="/showcase" className="navLink">Showcase</Link> 
        <Link to="/specs" className="navLink">Content</Link>
        <Link to="/faq" className="navLink">FAQ</Link>
        <Link to="/">
          <Button type="submit" className="btn-link">Acessar</Button>
        </Link>
      </nav>
    </header>
  );
};

export default Header;
